<template>
  <div>
    <!-- <v-menu
            ref="timeMenu"
            :close-on-content-click="false"
            v-model="timeMenu"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
    >-->
    <v-text-field
      slot="activator"
      ref="timeField"
      color="indigo"
      mask="time"
      :rules="timeRules"
      :value="value"
      @input="fieldInput"
      :label="label"
      prepend-icon="access_time"
    ></v-text-field>
    <!-- <v-time-picker
            format="24hr"
            scrollable
            :color="$store.state.global.pages.docket.color"
            :value="value"
            @input="pickerInput"
            full-width
            ></v-time-picker>
    </v-menu>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeMenu: false,
      // startRules: [
      //     v => (
      //         !!this.end ? !!v : true
      //     ) || 'Must enter end and start times',
      //     v => (
      //         !this.siteWeight ? !!v : true
      //     ) || 'Must enter either Tip Weight or start / end times'
      // ],
      // endRules: [
      //     v => (
      //         !!this.start ? !!v : true
      //     ) || 'Must enter end and start times',
      //     v => (
      //         !this.siteWeight ? !!v : true
      //     ) || 'Must enter either Tip Weight or start / end times'
      // ],
      timeRules: [
        //v => v == '' ? true : Moment(v, 'HH:mm', true).isValid() || 'Field must be valid 24hr time (HH:mm)',
        v => {
          if (!v) return true;
          if (v == "") return true;
          if (v.toString().length == 4 && !v.includes(":")) {
            v = `${v.slice(0, 2)}:${v.slice(2)}`;
          }
          var check = this.checkTime(v);
          if (!check) return "Field must be valid 24hr time (HH:mm)";
          return check;
          //v == '' ? true : this.checkTime(v) || 'Field must be valid 24hr time (HH:mm)'
        }
        // v => (
        //     !!this.end ? !!v : true
        // ) || 'Must enter end and start times',
        // v => (
        //     !this.siteWeight ? !!v : true
        // ) || 'Must enter either Tip Weight or start / end times'
      ]
    };
  },
  props: {
    value: String,
    label: String
  },
  methods: {
    checkTime(v) {
      if (v.length < 5) return false;
      var strings = v.split(":");
      if (Number(strings[0]) > 23) return false;
      if (Number(strings[1]) > 59) return false;
      return true;
    },
    pickerInput(val) {
      this.$emit("input", val);
      this.timeMenu = false;
    },
    fieldInput(val) {
      if (val.toString().length == 4) {
        val = val.replace(/(.{2})$/, ":$1");
      }
      console.log(val);

      this.$emit("input", val);
      this.timeMenu = false;
    },
    toggleTimePicker() {
      this.timeMenu = !this.timeMenu;
    }
  }
};
</script>

<style>
</style>
